import React, { useRef, useEffect } from "react";
import classnames from "classnames";

const AutoCloseMenu = ({
  showMenu,
  setShowMenu,
  children,
  className = "",
  styles,
  fixedPosition = false,
}) => {
  const wrapperRef = useRef();

  useEffect(() => {
    const handleClickOutside = evt => {
      if (wrapperRef.current && !wrapperRef.current.contains(evt.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [wrapperRef]);

  return (
    <div
      ref={wrapperRef}
      style={{ ...styles, display: showMenu ? "block" : "none" }}
      className={classnames(!fixedPosition && "border profile-menu", className)}
    >
      {children}
    </div>
  );
};

export default AutoCloseMenu;
